// extracted by mini-css-extract-plugin
export default {"appHeaderText":"styles_appHeaderText__OHkA5","dropdownItemWrap":"styles_dropdownItemWrap__ubOpv","icons":"styles_icons__5orP-","appText":"styles_appText__27EQi"};